
class ChUtils {
  
  /**
   * Валидирует швейцарский MWST (налог на добавленную стоимость)
   * @param {string} value - MWST для валидации
   * @returns {string|null} Ошибка валидации или null если корректный
   */
  static validateMWST(value) {
    if (typeof value !== 'string') return null;
    if (!/^CHE-\d{3}\.\d{3}\.\d{3}\s+(IVA|TVA|MWST)$/g.test(value)) return 'Некорректный MWST';
    return null;
  }

}

export default ChUtils;